import { Fragment, MouseEvent } from 'react';

import { Box } from 'components/Box';
import { Hide } from 'components/Hide';
import { StyledNativeLinkWithRef } from 'components/Link/StyledNativeLinkWithRef';
import { H1 } from 'components/Text/H1';
import { ApiOrg } from 'modules/listing/api/org/types/ApiOrg';
import { ListingTypeLabel } from 'modules/listing/components/ListingTypeLabel/ListingTypeLabel';
import { getCityStateString } from 'utils/address/getCityStateString';
import { getSocialNetworkFromLink } from 'utils/social/getSocialNetworkFromLink';
import { formatToHumanReadableUrl } from 'utils/string/formatToHumanReadableLink/formatToHumanReadableUrl';

import { ViewOrgPageActionButtons } from './ViewOrgPageActionButtons';

type Props = {
  org: ApiOrg;
  isPreview: boolean;
  onClickOpportunities: (
    e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
    analyticsProperties?: Record<string, unknown>,
  ) => void;
};

export function ViewOrgPageHeader({
  org,
  isPreview,
  onClickOpportunities,
}: Props) {
  const nonSocialLinks = org.links.filter(
    (link) => !getSocialNetworkFromLink(link),
  );

  return (
    <>
      <Box mb="24px">
        <ListingTypeLabel listingType="ORG" orgType={org.orgType} />
      </Box>

      <H1
        styleAs="h2"
        color="mediumContentGrey"
        data-qa-id="listing-name"
        lineHeight={1}
        mb="24px"
      >
        {org.name}
      </H1>
      <Box
        lineHeight={1}
        mb={['12px', null, null, '24px']}
        display="flex"
        alignItems="center"
        gridGap={16}
      >
        {org.address && <div>{getCityStateString(org.address)}</div>}

        {nonSocialLinks.map((link) => (
          <Fragment key={link}>
            <div>{' | '}</div>
            <StyledNativeLinkWithRef
              href={link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {formatToHumanReadableUrl(link)}
            </StyledNativeLinkWithRef>
          </Fragment>
        ))}
      </Box>
      <Hide xs sm md>
        <div>
          <ViewOrgPageActionButtons
            org={org}
            isPreview={isPreview}
            onClickOpportunities={onClickOpportunities}
            mobile={false}
          />
        </div>
      </Hide>
    </>
  );
}
